import React, { memo } from 'react';
import PropTypes from 'prop-types';

import Icon from '@/components/Base/Icon';

import {
  ActionText,
  ActionTitle,
  ProductActionsItem,
  ProductActionsList,
} from './ProductActions.styles';

function ProductActions({ actions = [] }) {
  return (
    <ProductActionsList>
      {actions.map(({ title, description }) => (
        <ProductActionsItem key={title}>
          <ActionTitle>
            <Icon name="action" width="24" />

            {title}
          </ActionTitle>

          <ActionText>{description}</ActionText>
        </ProductActionsItem>
      ))}
    </ProductActionsList>
  );
}

ProductActions.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({ title: PropTypes.string, description: PropTypes.string })
      .isRequired
  ),
};

export default memo(ProductActions);
